export class DialogData {
  constructor(public titulo: string, public pergunta: string) {

  }
}
